
<div>
  <PoppinsCheckbox
    v-model="serviceSelected"
    :checkboxId="checkboxId"
    :name="checkboxId"
    :labelName="serviceRate.checkboxLabel"
    :aria-label="generateScreenReaderLabel(serviceRate.checkboxLabel)"
    @change="resetRate()"
  />
  <PoppinsTextField
    v-if="serviceSelected"
    :id="textFieldId"
    :value="rate"
    :name="textFieldId"
    class="pb-24"
    :labelName="serviceRate.inputLabel"
    :aria-label="'Set your minimum rate'"
    type="text"
    pattern="[0-9]*"
    inputmode="numeric"
    :required="true"
    :status="formStatuses.rate"
    :helperText="helperText"
    :limit-input-to-pattern="true"
    @input="onInput"
    @blur="validate"
  />
</div>
